import { makeStyles } from 'vendor/material';
import { Box } from 'vendor/material';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'grid',
    gridTemplateRows: '1fr auto',
    height: '100%',
    overflow: 'hidden',
  },
  footer: {
    '&:empty': {
      display: 'none',
    },
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.NEUTRAL020}`,
  },
  content: {
    color: theme.palette.NEUTRAL700,
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    lineHeight: theme.typography.pxToRem(20),
    fontSize: theme.typography.pxToRem(12),
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    scrollbarColor: `${theme.palette.NEUTRAL100} ${theme.palette.NEUTRAL020}`,
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
      borderRadius: 0,
      backgroundColor: theme.palette.NEUTRAL020,
    },
    '&::-webkit-scrollbar': {
      width: 3,
      backgroundColor: '#F5F5F5',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,.3)',
      backgroundColor: theme.palette.NEUTRAL100,
    },
  },
}));

/**
 * A component for which renders a footer at the bottom of the container
 * if the WidgetContainer.Footer component is used and children are provided.
 */
function WidgetContainer({ children }: { children: React.ReactNode }) {
  const { wrapper } = useStyles();
  return <div className={wrapper}>{children}</div>;
}

function WidgetContent({ children }: { children: React.ReactNode }) {
  const { content } = useStyles();
  return <div className={content}>{children}</div>;
}
function Footer({ children }: { children?: React.ReactNode }) {
  const { footer } = useStyles();
  return <Box className={footer}>{children}</Box>;
}

WidgetContainer.Content = WidgetContent;
WidgetContainer.Footer = Footer;
WidgetContainer.displayName = 'WidgetContainer';

export { WidgetContainer };
